import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    name: 'chargesSlice',
    charges: {},
    error: null,
    uloader: false,
    loading: false,
    drivercharges: [],
}

export const getChargeReq = createAsyncThunk('getChargeReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/get/ride/price`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})
export const updateChargeReq = createAsyncThunk('updateChargeReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/update/ride/price`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const activateChargeReq = createAsyncThunk('activateChargeReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/update/ride/price`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const createDriverChargeReq = createAsyncThunk('createDriverChargeReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/create/driver/charges`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(getDriverChargeReq({}))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const getDriverChargeReq = createAsyncThunk('getDriverChargeReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/driver/charges/list`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteDriverChargeReq = createAsyncThunk('deleteDriverChargeReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/driver/charges/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(getDriverChargeReq({}))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

const chargesSlice = createSlice({
    name: 'charges',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(getChargeReq.pending, (state, action) => {
            state.loading = true
            state.charges = {}
            return state
        })
        builder.addCase(getChargeReq.fulfilled, (state, action) => {
            state.loading = false
            state.charges = action.payload.data
            return state
        })
        builder.addCase(getChargeReq.rejected, (state, action) => {
            state.loading = false
            state.charges = {}
            state.error = 'Error occured'
            return state
        })
        builder.addCase(updateChargeReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(updateChargeReq.fulfilled, (state, action) => {
            state.uloader = false
            state.charges = action.payload.data
            return state
        })
        builder.addCase(updateChargeReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
            return state
        })
        builder.addCase(activateChargeReq.pending, (state, action) => {
            return state
        })
        builder.addCase(activateChargeReq.fulfilled, (state, action) => {
            state.charges = action.payload.data
            return state
        })
        builder.addCase(activateChargeReq.rejected, (state, action) => {
            state.error = 'Error occured'
            return state
        })

        builder.addCase(createDriverChargeReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(createDriverChargeReq.fulfilled, (state, action) => {
            state.uloader = false
            return state
        })
        builder.addCase(createDriverChargeReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
            return state
        })

        builder.addCase(getDriverChargeReq.pending, (state, action) => {
            state.loading = true
            state.drivercharges = []
            return state
        })
        builder.addCase(getDriverChargeReq.fulfilled, (state, action) => {
            state.loading = false
            state.drivercharges = action.payload.data
            return state
        })
        builder.addCase(getDriverChargeReq.rejected, (state, action) => {
            state.loading = false
            state.drivercharges = []
            state.error = 'Error occured'
            return state
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default chargesSlice.reducer;
